import axios from "axios";
import tools from "../../kits/Tools.js";

const state = {
	dsInfo: null,
	userConfig: null,
	businessConfigs:{},
	miniConfig:{
		mp_1v1_orgin_id:'gh_1cc817b85e19',
		mp_1v1_appid:'wxa9458d482da70248',
		shop_login_mp_appid:'wx9dd18086e544c524',
		login_mp_appid:'wx308cba4bdeb1b6c7'
	},
	Sendflowers: 'true',
	wechat_mp_url:''
  }
  
  const getters = {
	getDsFuncInfo(){
		if(state.dsInfo){
			return state.dsInfo.ds_func
		}else{
			return null
		}
	},
	getDsInfo(state) {
		if(state.dsInfo){
			return state.dsInfo.direct_seeding
		}else{
			return null
		}
	},
	getDsId(state) {
		if(state.dsInfo){
			return state.dsInfo.direct_seeding
		}else{
			return null
		}
	},
	getUid(state) {
		if(state.dsInfo){
			return state.dsInfo.direct_seeding.uid
		}else{
			return null
		}
	},
	getRoomId(state) {
		if(state.dsInfo){
			return state.dsInfo.direct_seeding.room_id
		}else{
			return null
		}
	},
	getUserConfig(state){
		return state.userConfig
	},
	getBusinessConfigs(state){
		return state.businessConfigs
	},
	getSendflowers(state){
		return state.Sendflowers
	},
	getMiniConfig(state){
		return state.miniConfig
	},
	getWechat_mp_url(state){
		return state.wechat_mp_url
	}
  }
  
  const mutations = {
	setDsInfo(state, value) {
		state.dsInfo = value
	},
	setUserConfig(state, value){
		state.userConfig = value
	},
	setBusinessConfigs(state,value){
		state.businessConfigs = value
	},
	setSendflowers(state,value) {
		state.Sendflowers = value
	},
	setMiniConfig(state,value){
		state.miniConfig = value
	},
	setWechat_mp_url(state,value){
		state.wechat_mp_url = value;
	}
  }
  
  const actions = {
	  getDsInfo({ commit, dispatch }, dsInfo){
		commit('setDsInfo',dsInfo)
		const uid = dsInfo.direct_seeding.uid
		dispatch('getDsConfig',{uid})
	  },
	  getDsConfig({commit},{uid}){

		   axios.get(`https://tengfaceliveuser.tengface.net/web/config/miniConfig.json?ran=${new Date().valueOf()}`).then((resdata)=>{
				if(resdata.status == 200){
					commit('setMiniConfig',resdata.data || {})
					if (resdata.data.wx_qrcode_webview_url) {
						commit("setWechat_mp_url",resdata.data.wx_qrcode_webview_url)
					}
					axios.get(`https://tengface-live-user.oss-cn-shenzhen.aliyuncs.com/web/config/userConfig/${uid}.json?ran=${new Date().valueOf()}`).then((data)=>{
						if(data.status == 200){
								commit('setUserConfig',data.data)
								if (data.data.wechat_mini_url) {
									commit("setWechat_mp_url",data.data.wechat_mini_url)
								}
							}
						}).catch(()=>{
						})
					}
				}).catch(()=>{
					axios.get(`https://tengface-live-user.oss-cn-shenzhen.aliyuncs.com/web/config/userConfig/${uid}.json?ran=${new Date().valueOf()}`).then((data)=>{
					if(data.status == 200){
							commit('setUserConfig',data.data)
							if (data.data.wechat_mini_url) {
								commit("setWechat_mp_url",data.data.wechat_mini_url)
							}
						}
					}).catch(()=>{
					})
				})
		    
		  axios.get(`${tools.baseUrl1()}/customer/index/qryUserConfigs?uid=${uid}`).then((data)=>{
				console.log("data,====",data)
			if(data.data.code == 200){
				   if (Array.isArray(data.data.data)) {
						  let businessConfigs = {}
							data.data.data.forEach(element => {
							  	businessConfigs[element.key] = (element.value == 'true');
								  if(element.key == 'show_likes_and_flowers') {
									commit('setSendflowers',element.value);
								  }
							});
							commit('setBusinessConfigs',businessConfigs)
					 }
				}
			}).catch(()=>{
			})
			
	  },
  }
  
  export default {
	state,
	getters,
	mutations,
	actions,
	namespaced: true
  }
  


// WEBPACK FOOTER //
// ./src/store/modules/DsInfo.js